import { memo, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useFetching from "@source/hooks/useFetching";
import FamilyMemberController from "@source/api/controllers/familyMemberController";
import { IConfirmAddRequestResponse } from "@source/api/models/familyMemberModels";
import styles from "./AddRequestCompletePage.module.scss";
import { useHistory } from "react-router-dom";
import Button from "@source/components/UI/buttons/button/button";
import { LogoType, ROUTES } from "@source/utils/utils";
import authBackLines from "@source/assets/imgs/authBackLines.png";
import iconAccounHasBeenActivated from "@source/assets/icons/iconAccounHasBeenActivated.svg";
import Logo from "@source/components/UI/logo/logo";

const AddRequestCompletePage = memo(() => {
  const router = useHistory();
  const location = useLocation();
  const [confirmRequest, confirmRequestIsLoading, confirmRequestError] = useFetching<IConfirmAddRequestResponse>(FamilyMemberController.confirmAddRequest);
  const [response, setResponse] = useState<IConfirmAddRequestResponse | null>(null);

  useEffect(() => {
    const handleConfirmRequest = async () => {
      const params = new URLSearchParams(location.search);
      const id = params.get("id");
      const code = params.get("code");
      const completedBy = params.get("completedBy");
      const status = params.get("status");

      if (!id || !code || !completedBy || !status) {
        return;
      }

      const result = await confirmRequest({
        id,
        code,
        completedBy,
        status,
      });

      if (result) {
        setResponse(result);
      }
    };

    handleConfirmRequest();
  }, [location.search]);

  console.log(confirmRequestError)

  return (
    <div className={styles.addRequestComplete}>
      <div className={styles.addRequestComplete__inner}>
        <Logo
          className={styles.addRequestComplete__inner_logo}
          type={LogoType.White}
        />

        <div className={styles.addRequestComplete__form}>
          {confirmRequestError ? <></> : <img
            className={styles.addRequestComplete__form__icon}
            src={iconAccounHasBeenActivated}
            alt="completedIcon"
          />}

          {confirmRequestIsLoading && (
            <span className={styles.addRequestComplete__form__text}>
              Processing your request...
            </span>
          )}

          {!confirmRequestError && !confirmRequestIsLoading && response && (
            <>
              <span className={styles.addRequestComplete__form__text}>
                {response.message}. You will no longer receive reminders for this request.
              </span>
            </>
          )}

          {confirmRequestError && (
            <>
              <span className={styles.addRequestComplete__form__text_error}>
                {confirmRequestError}
              </span>
            </>
          )}
        </div>
      </div>

      <img
        className={styles.addRequestComplete_back}
        src={authBackLines}
        alt="lines"
      />
    </div>
  );
});

export default AddRequestCompletePage;
